const meta = {
  monitoring: 'Monitoring',
  team: 'Team',
};

export default meta;
